//#region IMPORTS
import env from '../config/env';
import service from '../api/history.service';
import permission from '../api/permissions.service';
import language from '../config/es';
//#endregion IMPORTS

//#region CONSTANTS

const initialData = {
    securityPermission: null,
    lsClientSeller: [],
    clientSeller: [],
    lsStatusPayment: [],
    lsHistory: [],
    lsDocumentTypeForStatus: [],
    lsDocumentTypeForHistory: [],
    lsStatusDocumentType:[],
    lsStatusPaymentType: [],
    noPermitted: ''
}
//#endregion CONSTANTS

//#region TYPES
const SECURITY_PERMISSIONS = 'SECURITY_PERMISSIONS';
const LOAD_CLIENT_SELLER = 'LOAD_CLIENT_SELLER';
const LOAD_CLIENT_SELLER_BY_ID = 'LOAD_CLIENT_SELLER_BY_ID';
const LOAD_STATUS_PAYMENT_CLIENT = 'LOAD_STATUS_PAYMENT_CLIENT';
const LOAD_PAYMENT_HISTORY_CLIENT = 'LOAD_PAYMENT_HISTORY_CLIENT';
const LOAD_DOCUMENT_TYPE_FOR_STATUS = 'LOAD_DOCUMENT_TYPE_FOR_STATUS';
const LOAD_DOCUMENT_TYPE_FOR_HISTORY = 'LOAD_DOCUMENT_TYPE_FOR_HISTORY';
const LOAD_STATUS_DOCUMENT_TYPES = 'LOAD_STATUS_DOCUMENT_TYPES';
const LOAD_STATUS_PAYMENT_TYPES = 'LOAD_STATUS_PAYMENT_TYPES';
const RESPONSE_ERROR = 'RESPONSE_ERROR';
//#endregion TYPES

//#region REDUCER

export default function historyReducer(state = initialData, action) {
    switch (action.type) {
        case SECURITY_PERMISSIONS:
            return { ...state, securityPermission: action.payload };
        case LOAD_CLIENT_SELLER:
            return { ...state, lsClientSeller: action.payload };
        case LOAD_CLIENT_SELLER_BY_ID:
            return { ...state, clientSeller: action.payload };
        case LOAD_STATUS_PAYMENT_CLIENT:
            return { ...state, lsStatusPayment: action.payload };
        case LOAD_PAYMENT_HISTORY_CLIENT:
            return { ...state, lsHistory: action.payload };
        case LOAD_DOCUMENT_TYPE_FOR_STATUS:
            return { ...state, lsDocumentTypeForStatus: action.payload };
        case LOAD_DOCUMENT_TYPE_FOR_HISTORY:
            return { ...state, lsDocumentTypeForHistory: action.payload };
        case LOAD_STATUS_DOCUMENT_TYPES:
            return { ...state, lsStatusDocumentType: action.payload };
        case LOAD_STATUS_PAYMENT_TYPES:
            return { ...state, lsStatusPaymentType: action.payload };
        case RESPONSE_ERROR:
            return { ...state, noPermitted: action.payload };
        default:
            return { ...state };
    }
}
//#endregion REDUCER

//#region ACTIONS
export const getPermissions = (username, action) => async (dispatch) => {
    const response = await permission.validPermission(
        env.transaction.historyPayment,
        username,
        env.app.systemCode, action);
    dispatch({
        type: SECURITY_PERMISSIONS,
        payload: response
    });
    return response;
}

export const getFindAllClientSeller = (json) => async (dispatch) => {
    const response = await service.getFindAllClientSeller(json).then((r) => { return r });
    dispatch({
        type: LOAD_CLIENT_SELLER,
        payload:response
    });
    return response;
}

export const getFindAllClientSellerById = (json) => async (dispatch) => {
    const response = await service.getFindAllClientSellerById(json).then((r) => { return r });
    dispatch({
        type: LOAD_CLIENT_SELLER_BY_ID,
        payload:response
    });
    return response;
}

export const getFindAllPaymentHistoryByClient = (client,json) => async (dispatch) => {
    const response = await service.getFindAllPaymentHistoryByClient(client,json).then((r) => { return r });
    dispatch({
        type: LOAD_PAYMENT_HISTORY_CLIENT,
        payload:response
    });
    return response;
}

const buildOptionsFromResponse = (res, dispatch, getValue) => {
    let data = [];
    data.push({
        value: "",
        label: 'Todos'
    });
    if (res != null) {
        if (res.status === 200) {
            res.data.forEach((element) => {
                data.push({
                    value: getValue(element),
                    label: element.name.toUpperCase()
                });
            });
        } else if (res.response.status === 403) {
            dispatch({
                type: RESPONSE_ERROR,
                payload: res.response.data
            });
        } else {
            dispatch({
                type: RESPONSE_ERROR,
                payload: language.messages.msmErrorExist
            });
        }
    }
    return data;
}

export const findAllDocumentTypeForHistory = () => async (dispatch) => {
    const res = await service.getAllDocumentTypeForHistory().then((r) => { return r});
    const data = buildOptionsFromResponse(res, dispatch, (element) => element.value);
    dispatch({
        type: LOAD_DOCUMENT_TYPE_FOR_HISTORY,
        payload: data
    });
}

export const findAllStatusDocumentTypes = () => async (dispatch) => {
    const res = await service.getAllStatusDocumentTypes().then((r) => { return r});
    const data = buildOptionsFromResponse(res, dispatch, (element) => element.code);
    dispatch({
        type: LOAD_STATUS_DOCUMENT_TYPES,
        payload: data
    });
}

export const findAllStatusPaymentTypes = () => async (dispatch) => {
    const res = await service.getAllStatusPaymentTypes().then((r) => { return r});
    const data = buildOptionsFromResponse(res, dispatch, (element) => element.code);
    dispatch({
        type: LOAD_STATUS_PAYMENT_TYPES,
        payload: data
    });
}
//#endregion ACTIONS
